import Patch from "@shared/models/patch-updater"

export const COURSE_SET_RECENTLY_IMPORTED_COURSES = {
  name: "COURSE_SET_RECENTLY_IMPORTED_COURSES",

  params: {
    courseId: "string",
    recentlyImportedCourses: "array",
  },

  patches(payload) {
    let patch = Patch.create("course", payload.courseId).set(
      "attributes.recentlyImportedCourses",
      payload.recentlyImportedCourses
    ).patch
    return [patch]
  },

  undoPatches: null,

  narrative: null,
}

export default COURSE_SET_RECENTLY_IMPORTED_COURSES
